module.exports = __webpack_public_path__ + "img/istock-907916910.0b6f3b0f.webp";